<script setup lang="ts">
import { h } from 'vue'
import {useAuthStore} from "~~/stores/auth";
const localePath = useLocalePath()
const { t } = useI18n()
const auth = useAuthStore()

const IconMyAccount = defineComponent({
    name: 'IconMyAccount',
    inheritAttrs: false,
    setup(_, { attrs }) {
        return () =>
            h(
                'svg',
                { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 26 31', ...attrs },
                [
                    h('path', { fill: '#3D0703', d: 'M25.79 26.14C25.79 25.94 25.79 25.73 25.78 25.52C25.53 20.34 22.14 15.91 17.5 14.12C19.45 12.7 20.73 10.41 20.73 7.81C20.73 3.5 17.24 0.0100021 12.93 0.0100021C8.62 0.0100021 5.13 3.5 5.13 7.81C5.13 10.4 6.4 12.69 8.34 14.11C3.48 15.94 0.03 20.61 0 26.1C0 26.1 0 26.13 0 26.15C0 28.49 1.9 30.39 4.24 30.39H21.55C23.89 30.39 25.79 28.49 25.79 26.15V26.14ZM12.92 2.4C15.9 2.4 18.32 4.82 18.32 7.8C18.32 10.78 15.9 13.2 12.92 13.2C9.94 13.2 7.52 10.78 7.52 7.8C7.52 4.82 9.94 2.4 12.92 2.4ZM21.55 27.99H4.24C3.22 27.99 2.4 27.16 2.4 26.15C2.4 26.13 2.4 26.12 2.4 26.1C2.43 20.34 7.13 15.66 12.89 15.66C13.09 15.66 13.3 15.66 13.5 15.68C18.78 15.98 23.11 20.35 23.37 25.64C23.37 25.81 23.38 25.97 23.38 26.14C23.38 27.16 22.55 27.98 21.54 27.98L21.55 27.99Z' }),
                ]
            )
    }
})

</script>

<template>
    <ULink v-if="auth.user != null" :to="localePath('moj-racun')" :aria-label="t('header.menuItems.openMyAccount')">
        <UIcon :name="IconMyAccount" class="h-[24px] lg:h-[30px] w-auto" />
    </ULink>
    <ULink v-else :to="localePath('moj-racun-prijava')" :aria-label="t('header.menuItems.openMyAccount')">
        <UIcon :name="IconMyAccount" class="h-[24px] lg:h-[30px] w-auto" />
    </ULink>
</template>

<style scoped>

</style>
